/** Die Seite der Prozessansicht für eine Abteilung, deren Floating-Plätze alle belegt sind (`SeatUnavailableState`). Die Texte zu den Plätzen sind `seats.unavailable`. */
export default {
	seat: {
		tryAgain: "Erneut versuchen",
		openDepartment: "{department} öffnen",
	},
};
